import React from 'react';
import LogoImage from './icons/hawkish2.svg';

const Logo = ({className})=> {
    return (
        <img src={LogoImage} className={className} />
    )
}

export default Logo;